import React from 'react';

const Checkbox = ({ value, className = '', checked = false, onChange }) => {
  const handleChange = () => {
    if (onChange instanceof Function) onChange(value);
  };

  return (
    <label
      htmlFor={value.slug}
      className={`c-holiday-finder__checkbox ${
        checked ? 'c-holiday-finder__checkbox--checked' : ''
      } ${className}`}
      onChange={handleChange}
    >
      <input
        checked={false}
        id={value.slug}
        type="checkbox"
        name={value.slug}
        value={value.display}
        readOnly
      />

      <span dangerouslySetInnerHTML={{ __html: value.display }}></span>
    </label>
  );
};

export default Checkbox;
